import {
  Route,
  RouteConfig,
} from 'vue-router';

import {
  store,
} from '@/store';
import {
  NavigationGuardNext,
} from '@/store/types';

export const authRoutes: RouteConfig[] = [

  /*
   * TODO: Ожидает готовности бэкенда
   * {
   *   path: '/register',
   *   name: 'register',
   *   component: (): Promise<typeof import('*.vue')> => import('../views/Register.vue'),
   * },
   */
  {
    path: '/login',
    name: 'login',
    beforeEnter: (): void => {
      location.assign(`${__config.url.app}/login`);
    },
  },

  /*
   * TODO: Ожидает готовности бэкенда
   * {
   *   path: '/restore-password',
   *   name: 'restore-password',
   *   beforeEnter: (to: Route, from: Route, next: NavigationGuardNext): void => {
   *     const isAuthenticated = store.getters['auth/isAuthenticated'];
   *     const isProfileLoaded = store.getters['profile/isLoaded'];
   *     const profileData = store.getters['profile/data'];
   *
   *     if (isProfileLoaded && profileData) {
   *       location.replace(`${__config.url.auth}/restore-password?email=${profileData.email}`);
   *     } else if (isAuthenticated) {
   *       next({ name: 'home' });
   *     } else {
   *       next({ name: 'landing' });
   *     }
   *   },
   *   component: (): Promise<typeof import('*.vue')> => import('../views/Login.vue'),
   *   meta: {
   *     onlyAuth: false,
   *   },
   * },
   */
  {
    path: '/logout',
    name: 'logout',
    beforeEnter: (to: Route, from: Route, next: NavigationGuardNext): void => {
      store.dispatch('auth/logout');
      next({ name: 'home' });
    },
  },
];
